<template>
  <form
    class="stack size-3 phone-verify-code"
    @submit.prevent="onSubmit"
  >
    <div :class="{ disabled: submitting }">
      <p class="line-height-2">
        <i18n-t keypath="accountSettings.generalInfo.phoneNumber.modal.description">
          <template #phone>
            <strong>{{ mobilePhone }}</strong>
          </template>
        </i18n-t>
      </p>
      <p class="line-height-2 font-size-1 mt-0">
        <i18n-t keypath="accountSettings.generalInfo.mfa.modal.helpText">
          <a
            href="https://support.talkingparents.com/hc/en-us"
            target="_self"
            class="font-size-1 brand underline text-center mt-3"
          >
            {{ t('accountSettings.generalInfo.mfa.modal.helpCenter') }}
          </a>
        </i18n-t>
      </p>
    </div>
    <div class="place-center">
      <code-input
        @codeResult="handleCodeResult"
        :disabled="submitting"
        :class="{ disabled: submitting }"
        :error-state-override="errorMessage.length > 0"
        required
      />
    </div>
    <span
      v-if="errorMessage.length > 0"
      class="font-size-0 error"
      style="margin-top: 0.5rem"
    >
      {{ errorMessage }}
    </span>
    <button
      type="submit"
      class="btn primary"
      :disabled="!meta.dirty || !meta.valid || submitting"
    >
      <Loading :loading="submitting" />
      Verify
    </button>
    <button
      class="btn tertiary underline brand"
      type="button"
      @click="emit('resend')"
      style="font-weight: var(--font-weight-1)"
      :class="{ disabled: submitting }"
      :disabled="submitting"
    >
      {{ t('accountSettings.generalInfo.phoneNumber.modal.sendAnotherCode') }}
    </button>
    <span
      v-if="showResendSuccess"
      class="bg-lt-blue py-0 font-weight-2 font-size-0 radius-3 mt-2 text-center"
    >
      {{ t('forgotPassword.verifyCode.resentSuccess') }}
    </span>
  </form>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useForm } from 'vee-validate'
import { useI18n } from 'vue-i18n'
import CodeInput from '@/components/CodeInputComponent.vue'
import Loading from '@/components/library/Loading.vue'

const { t } = useI18n({ useScope: 'global' })

defineProps<{
  mobilePhone: string
  errorMessage: string
  submitting: boolean
  showResendSuccess: boolean
}>()

const emit = defineEmits<{
  (e: 'submit', code: string): void
  (e: 'resend'): void
  (e: 'codeChange'): void
}>()

const { meta, handleSubmit } = useForm()

const codeResult = ref('')

const onSubmit = handleSubmit(() => {
  emit('submit', codeResult.value)
})

function handleCodeResult(value: string) {
  codeResult.value = value
  emit('codeChange')
}
</script>

<style lang="scss" scoped>
.phone-verify-code {
  p {
    text-align: center;
    margin-top: 0;
    margin-bottom: 0;
  }
}

.disabled {
  opacity: 0.5;
}
</style>
